module.exports = __webpack_public_path__ + "static/media/package_design_brandbook.8fce43c3.svg";